import identity from "lodash/fp/identity";

class PlansPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default PlansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/plans/plans.transforms.js